import React from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineContent } from '@mui/lab';

const milestones = [
  {
    date: 'July 2024',
    title: 'Incorporated',
    description: 'Anthrasync Solutions Private Limited was officially registered and incorporated.',
  },
  {
    date: 'August 2024',
    title: 'Startup India Recognition',
    description: 'Received recognition under the Startup India program, validating our innovation and growth potential.',
  },
  {
    date: 'Nov 2024',
    title: 'Official Website Launch',
    description: 'Our official company website went live, offering users a central place to learn about our services.',
  },
  {
    date: 'January 2025',
    title: 'First Basic Version Platform Launch',
    description: 'We released the first version of our core platform with essential features for early adopters.',
  },
  {
    date: 'April 2025',
    title: 'Major Update',
    description: 'Rolled out a significant update with improved UI/UX, performance enhancements, and new capabilities.',
  },
];


const JourneyPage = () => {
  return (
    <Box
  id="journey"
  sx={{
    py: { xs: 6, md: 10 },
    px: { xs: 3, md: 6 },
    backgroundColor: '#000000',
    color: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mb: 10,
  }}
>
  <Typography
    component="h2"
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 8,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      animation: 'fadeIn 2s ease-in-out',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Our Journey So Far
  </Typography>

  <Box
    sx={{
      width: '100%',
      maxWidth: '900px',
      border: '2px solid transparent',
      borderRadius: 3,
      transition: 'border-color 0.3s ease',
      '&:hover': {
        borderColor: '#1E90FF',
      },
    }}
  >
    <Timeline position="alternate">
      {milestones.map((milestone, index) => (
        <TimelineItem key={index}>
          <TimelineSeparator>
            <TimelineDot color="primary" />
          </TimelineSeparator>
          <TimelineContent sx={{ ml: 2 }}>
            <Typography
              variant="h6"
              component="h3"
              sx={{
                letterSpacing: 3,
                fontWeight: 500,
                color: 'white',
                '&:hover': {
                  color: '#1E90FF',
                },
              }}
            >
              {milestone.title}
            </Typography>
            <Typography variant="body2" sx={{ color: '#ccc', letterSpacing: 2 }}>
              {milestone.description}
            </Typography>
            <Typography variant="body2" sx={{ color: 'grey.500', letterSpacing: 2 }}>
              {milestone.date}
            </Typography>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  </Box>
</Box>
  );
};

export default JourneyPage;
